type Props = {
  direction: 'left' | 'right'
  onClick: () => void
  disabled?: boolean
}

export function ArrowButton({ direction, onClick, disabled = false }: Props) {
  const iconColor = disabled ? '#C6C6C6' : '#8996A2'

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={direction === 'right' ? 'Próxima página' : 'Página anterior'}
      className="w-[40px] h-[40px] rounded-full border border-[#EBEBEB] flex items-center justify-center disabled:cursor-not-allowed"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="14"
        viewBox="0 0 8 14"
        fill="none"
        className={direction === 'right' ? 'rotate-180' : ''}
      >
        <path
          d="M2.828 7.00023L7.778 11.9502L6.364 13.3642L0 7.00023L6.364 0.63623L7.778 2.05023L2.828 7.00023Z"
          fill={iconColor}
        />
      </svg>
    </button>
  )
}
